import React from 'react';
import { useParams } from 'react-router-dom';
import MyTable from 'components/UIElements/MyTable';
import EndPoints from 'shared/endPoints/EndPoints.json';
import {getPermissionColumns} from 'shared/utils/getPermissionColumns';

export default function Permissions() {
    const { id } = useParams();

    const columns = getPermissionColumns()
    const dataTransformer = (items) => {
        if (!items) return [];
        const flattenedData = items.flatMap(item => item.permissionNames || []);
        return flattenedData.map((item, index) => ({
            ...item,
            key: item.uniqueId || index
        }));
    }

    return (
        <MyTable
            endPoint={`${EndPoints.REPORTS.GETPERMISSIONS}?contractId=${id}`}
            columns={columns}
            dataTransformer={dataTransformer}
            pageSize={100}
        />
    );
}